module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBoldItalic.0c8d918.ttf";